import * as React from 'react';
import { ChoiceGroupCore, } from '@core-front/choice-group';
import Check from '@telia-front/check';
import { getBackgroundColorClass, } from '@telia-front/colors';
import FormHelper from '@telia-front/form-helper';
import Radio from '@telia-front/radio';
const ChoiceGroup = (props) => {
    function innerColorClass() {
        if (props.background) {
            return getBackgroundColorClass(props.background);
        }
        return undefined;
    }
    return (React.createElement(ChoiceGroupCore, Object.assign({}, props, { components: {
            Radio,
            FormHelper,
            Check,
        }, innerColorClass: innerColorClass() })));
};
export { ChoiceGroup as default, };
